import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// JS2TS: the original define() imports ITSELF (WidgetCollection/SOV/legacy/Main/TravelExpenseList) but
// names the binding "TravelExpenseForm" and does `new TravelExpenseForm()` — a self-instantiation bug in
// the original (likely meant Main/TravelExpenseForm). Preserved 1:1 as a self-import.
import TravelExpenseForm from './TravelExpenseList';
import template from './templates/TravelExpenseList.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo dep (_base/connect). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class TravelExpenseList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    item: any = null;
    externalButton: any = null;
    jsonEntitylist: any = null;
    travelExpForm: any = null;
    sumrow = false;
    targetColumnname: any = null;

    startup(): void {

        //domClass.remove(this.showBtn, "w3-hide");
        //domClass.remove(this.hideBtn, "w3-hide");
        domClass.remove(this.reloadBtn, "w3-hide");
        if (this.item.LvlTravelExpenses > 50) {
            domClass.remove(this.newBtn, "w3-hide");
        }
        this.loadExpenses();
    }

    loadExpenses(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        domConstruct.empty(this.tableNode);
        domClass.remove(this.tableNode);

        var url = window.appRoot + "SOV/TravelExpensesGetExpensesOfProject";
        //var url = window.appRoot + "Orchestra/GetOtherMusiciansDispo";

        this.RequestManager.post(
            url,
            {
                associateID: this.item.ref_associate,
                projectID: this.item.ref_ev_project
            },
            lang.hitch(this, "_onLoadExpensesResponse"),
            lang.hitch(this, "_onLoadExpensesError"),
            false // sync
        );
    }

    _onLoadExpensesResponse(response: any): void {
        var jsonEntitylist = JSON.parse(response);


        this.set("data", jsonEntitylist);

    }

    _setNewButtonAttr(bool: any): void {

        if (bool !== false) {
            domClass.remove(this.newBtn, "w3-hide");
        } else {
            domClass.add(this.newBtn, "w3-hide");
        }
    }

    _setSumrowAttr(bool: any): void {

        this.sumrow = bool;
    }

    _setTargetColumnAttr(name: any): void {
        //console.debug("_setTargetColumnAttr", name);
        if (name && name != "all") {
            this.targetColumnname = name;
        } else {
            this.targetColumnname = null;
        }
    }

    _setButtonsAttr(bool: any): void {

        if (bool !== false) {
            domClass.remove(this.btnContainerNode, "w3-hide");
        } else {
            domClass.add(this.btnContainerNode, "w3-hide");
        }
    }

    _setDataAttr(data: any): void {

        this.jsonEntitylist = data;
        this.drawTable();
    }

    drawTable(): void {
        console.log("travelExpenseList drawTable", this.jsonEntitylist);
        let jsonEntitylist = this.jsonEntitylist;

        // Tabelle erzeugen....
        var table = domConstruct.create("table");
        domConstruct.place(table, this.tableNode);
        domClass.add(table, "SOV_travelExpensesTable");
        domStyle.set(table, "margin-bottom", "0");

        var thead = domConstruct.create("thead");
        domConstruct.place(thead, table);

        var row = domConstruct.create("tr");
        domConstruct.place(row, thead);

        // Spalten mit den Überschriften
        var col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Termin");

        col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Streckenbeschreibung");

        if (!this.targetColumnname || this.targetColumnname == "km_pool") {
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "km Fahrgem.");
            domClass.add(col, "w3-right-align");
        }

        if (!this.targetColumnname || this.targetColumnname == "km_single") {

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "km Einzelf.");
            domClass.add(col, "w3-right-align");
        }

        if (!this.targetColumnname || this.targetColumnname == "km_public") {

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "km öff.");
            domClass.add(col, "w3-right-align");
        }
        col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Status");
        domClass.add(col, "w3-right-align");

        var tbody = domConstruct.create("tbody");
        domConstruct.place(tbody, table);

        if (jsonEntitylist.length == 0) {
            var row = domConstruct.create("tr");
            domConstruct.place(row, thead);

            // Spalten mit den Überschriften
            var col = domConstruct.create("td");
            domAttr.set(col, "colspan", "6");
            domConstruct.place(col, row);
            domClass.add(col, "w3-center");
            domAttr.set(col, "innerHTML", "<i>keine Einträge</i>");
        }

        let sum_km_pool = 0;
        let sum_km_single = 0;
        let sum_km_public = 0;

        for (var i = 0; i < jsonEntitylist.length; i++) {
            var entity = jsonEntitylist[i];

            var color = entity.ref_webform_travelexpense_status.tmp_hex_color.split(":");

            row = domConstruct.create("tr");
            domConstruct.place(row, tbody);

            row.style.setProperty("--bgColor", "#" + color[0]);
            domClass.add(row, "colored");
            //domStyle.set(row, "background-color", "#" + color[0]);
            //domStyle.set(row, "color", "#" + color[1]);

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.ref_orchestra_employment.ref_ev_booking.gDisp_1);
            col.innerHTML += "<br>" + entity.ref_orchestra_employment.tmp_daterange_web;

            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.route_description.replace("\r\n", "<br>"));

            if (!this.targetColumnname || this.targetColumnname == "km_pool") {

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.km_pool);
                domClass.add(col, "w3-right-align");

                sum_km_pool += parseFloat(entity.km_pool);
            }

            if (!this.targetColumnname || this.targetColumnname == "km_single") {

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.km_single);
                domClass.add(col, "w3-right-align");

                sum_km_single += parseFloat(entity.km_single);
            }

            if (!this.targetColumnname || this.targetColumnname == "km_public") {

                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.km_public);
                domClass.add(col, "w3-right-align");

                sum_km_public += parseFloat(entity.km_public);
            }
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.ref_webform_travelexpense_status.description_D);
            domClass.add(col, "w3-right-align");

        }

        if (this.sumrow === true) {
            row = domConstruct.create("tr", {}, tbody);
            col = domConstruct.create("td", {}, row);
            col = domConstruct.create("td", { innerHTML: "km Summen:" }, row);
            domClass.add(col, "w3-right-align");

            if (!this.targetColumnname || this.targetColumnname == "km_pool") {

                col = domConstruct.create("td", { innerHTML: sum_km_pool }, row);
                domClass.add(col, "w3-right-align");
            }

            if (!this.targetColumnname || this.targetColumnname == "km_single") {

                col = domConstruct.create("td", { innerHTML: sum_km_single }, row);
                domClass.add(col, "w3-right-align");
            }

            if (!this.targetColumnname || this.targetColumnname == "km_public") {

                col = domConstruct.create("td", { innerHTML: sum_km_public }, row);
                domClass.add(col, "w3-right-align");
            }
            col = domConstruct.create("td", {}, row);
        }


        //spinners.global().stop();
        this.StandbyStop();

        if (this.externalButton != null) {
            domClass.add(this.externalButton, "w3-hide");
        }

        this._onClickShow();
    }

    _onLoadExpensesError(error: any): void {
        console.log("_onLoadExpensesError", error);
        //spinners.global().stop();
        this.StandbyStop();
    }

    _onClickReload(evt?: any): void {
        this.loadExpenses();
    }

    _onClickHide(evt: any): void {
        domClass.add(this.tableNode, "w3-hide");
    }

    _onClickShow(evt?: any): void {
        //domClass.remove(this.showBtn, "w3-hide");
        //domClass.remove(this.hideBtn, "w3-hide");
        domClass.remove(this.reloadBtn, "w3-hide");

        if (this.jsonEntitylist == null) {
            this._onClickReload(evt);
        } else {
            domClass.remove(this.tableNode, "w3-hide");
        }
    }

    _onClickNew(evt: any): void {
        if (this.travelExpForm == null) {
            this.travelExpForm = new TravelExpenseForm();

            this.travelExpForm.associateID = this.item.ref_associate;
            this.travelExpForm.projectID = this.item.ref_ev_project;

            this.travelExpForm.submitCallback = lang.hitch(this, "submitNewExpense");

            domAttr.set(this.headerNode, "innerHTML", "neuer Fahrtkosteneintrag - " + this.item.ProjectDescription);

            domConstruct.place(this.travelExpForm.domNode, this.modalContentNode);

            this.travelExpForm.startup();
        }

        domStyle.set(this.modalDlg, "display", "block");
    }

    _onClick_Modal_Close(evt?: any): void {
        domStyle.set(this.modalDlg, "display", "none");

        this.travelExpForm.destroy(); // optional?
        this.travelExpForm = null;
    }

    submitNewExpense(jsonData: any): void {

        console.log("submitNewExpense", jsonData);

        var url = window.appRoot + "SOV/TravelExpensesCreateNewTravelExpense";
        //var url = window.appRoot + "Orchestra/GetOtherMusiciansDispo";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, "_onSubmitNewExpenseResponse"),
            lang.hitch(this, "_onSubmitNewExpenseError"),
            false // sync
        );
    }

    _onSubmitNewExpenseResponse(response: any): void {
        this._onClick_Modal_Close();
        this._onClickReload();
    }

    _onSubmitNewExpenseError(error: any): void {
        this.travelExpForm.setMessage(error.Message);
        //spinners.global().stop();
        this.StandbyStop();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
TravelExpenseList.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.TravelExpenseList';

export default mdsWidget(TravelExpenseList);
